// extracted by mini-css-extract-plugin
export var grayCircle = "_dk-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_dk-1";
export var selectedCircle = "_dk-2";
export var shippingOptionImage = "_dk-3";
export var shippingOptionWidgetPreview = "_dk-4";